import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import { later, scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import _ from "lodash"

export default class Timelines extends Component {
  @service("ember-store")
  store

  // allTimelineHeight
  // timelineHeight

  courseTitleHeight = 40
  infoDateHeight = 0
  lessonBarHeight = 30
  addUnitBarHeight = 30

  didReceiveAttrs() {
    let currentIndex = _.findIndex(get(this, "dates"), {
      dateString: get(this, "selectedDate"),
    })
    let positionOfCurrentDate = currentIndex * get(this, "dateWidth")
    // add the lessonBarHeight as a bottom padding
    scheduleOnce("afterRender", () => {
      // set(this, 'timelineHeight', _.last(positioning).top)
      // set(this, 'positioning', positioning)
      if (
        get(this, "positionOfCurrentDate") !== positionOfCurrentDate &&
        _.isNumber(positionOfCurrentDate)
      ) {
        this.$(".js-timeline-wrapper").scrollLeft(positionOfCurrentDate - 200)
        set(this, "positionOfCurrentDate", positionOfCurrentDate)
      }
    })
  }

  @computed("courses.@each.internalVersion")
  get positioning() {
    super.positioning
    if (get(this, "courses") === null) return
    let maxDepths = _.compact(
      _.map(get(this, "courses"), (course) => {
        let maxDepth = _.max(
          _.map(course.attributes.calendar.dates, (d) => get(d, "attributes.unitIds.length") || 1)
        )
        return maxDepth
      })
    )

    let total = 0
    // let previousDepth = 0
    maxDepths.unshift(0)

    let offsets = _.map(maxDepths, (depth) => {
      total = total + depth
      // previousDepth = depth
      return total
    })
    offsets.unshift()

    let positioning = _.map(offsets, (offset, index) => {
      if (index === 0) {
        return {
          top: get(this, "infoDateHeight"),
          height: 0,
        }
      } else {
        return {
          top:
            offset * get(this, "barHeight") +
            get(this, "infoDateHeight") +
            get(this, "courseTitleHeight") * index +
            get(this, "addUnitBarHeight") * index +
            get(this, "lessonBarHeight") * index,
          // + 36 * index // The height of the show outline button
          height: 0,
        }
      }
    })
    let newPositioning = _.map(positioning, (hash, index) => {
      if (index == positioning.length - 1) return hash
      return _.assign(hash, {
        height: get(positioning[index + 1], "top") - hash.top,
      })
    })
    return newPositioning
  }

  @computed("positioning.@each.top")
  get timelineHeight() {
    // Not sure why this was undefined so doing a double check with _.compact and checking for undefined
    let last = _.last(_.compact(get(this, "positioning")))
    if (last === undefined) {
      return 10000
    } else {
      return last.top
    }
  }

  @computed("dates.length", "dateWidth")
  get timelineWidth() {
    return get(this, "dates.length") * get(this, "dateWidth")
  }

  showTimelineDates = true

  handleTimelineScroll() {
    if (this.isScrolling === true) $(".js-course-title-banner").css("opacity", 0)
    let scroller = this.$(".js-timeline-scroller")
    if (scroller !== undefined) {
      let { top, left } = scroller.offset()
      $(".js-unit-timeline-info-dates").scrollLeft(-left)
    }
    this._setTitleBannerDimensions()
  }

  didInsertElement() {
    // this._super(...arguments)
    // Ember.run.later(() => {
    //   set(this, 'showTimelineDates', true)
    // }, 1)
    later(() => {
      if (this.isDestroyed || this.isDestroying) return
      set(this, "showUnits", true)
    }, 1)
    this._setTitleBannerDimensions()
    let throttled = _.throttle(() => {
      this.handleTimelineScroll()
    }, 15)

    this.$(".js-timeline-wrapper").on("scroll", (e) => {
      throttled()
    })
  }

  isScrolling = false

  _setTitleBannerDimensions() {
    this.isScrolling = true
    if (this._setTitleBannerDimensionsTimer) clearTimeout(this._setTitleBannerDimensionsTimer)
    this._setTitleBannerDimensionsTimer = setTimeout(() => {
      let scroller = this.$(".js-timeline-scroller")
      if (scroller === undefined) return
      let { top, left } = scroller.offset()
      this.isScrolling = false
      $(".js-course-title-banner").css("opacity", 1)
      set(
        this,
        "courseTitleBannerStyle",
        `
        opacity:           1;
        -webkit-transform: translate3d(${left * -1}px, 0, 0);
        -moz-transform:    translate3d(${left * -1}px, 0, 0);
        -ms-transform:     translate3d(${left * -1}px, 0, 0);
        transform:         translate3d(${left * -1}px, 0, 0);
      `
      )
    }, 120)
  }

  @computed("rotationCalendar.attributes.version", "courses.@each.internalVersion")
  get dates() {
    let courseDateStrings = _.flatMap(get(this, "courses"), (course) => {
      return _.map(course.attributes.calendar.dates, "attributes.dateString")
    })
    let rotationDateStrings = _.map(
      get(this, "rotationCalendar.attributes.dates"),
      "attributes.dateString"
    )
    let allDateStrings = courseDateStrings.concat(rotationDateStrings)

    let minDate = _.flow(_.min, dateFns.parse, (d) => dateFns.subDays(d, 28))(allDateStrings)
    let maxDate = _.flow(_.max, dateFns.parse, (d) => dateFns.addDays(d, 28))(allDateStrings)

    let usedMonths = {}
    let rotationCalendarDateMap = _.keyBy(
      get(this, "rotationCalendar.attributes.dates"),
      "attributes.dateString"
    )
    let schoolDays = get(this, "rotationCalendar.attributes.schoolDays")
    let firstDateOfSchoolYear = _.min(
      _.map(get(this, "rotationCalendar.attributes.semesters"), (semester) => semester.startDate)
    )
    let lastDateOfSchoolYear = _.min(
      _.map(get(this, "rotationCalendar.attributes.semesters"), (semester) => semester.endDate)
    )
    return _.chain(dateFns.eachDay(minDate, maxDate))
      .filter((date) => _.includes(schoolDays, dateFns.getDay(date)))
      .map((date, index, array) => {
        let dateString = dateFns.format(date, "YYYY-MM-DD")
        let rotationDate = rotationCalendarDateMap[dateString]
        let isMonthStart = usedMonths[dateString.slice(0, 7)] !== true
        let nextDate = array[index + 1]
        let nextDateString = nextDate ? dateFns.format(nextDate, "YYYY-MM-DD") : null
        let isMonthEnd = nextDate
          ? isMonthStart !== true && usedMonths[nextDateString.slice(0, 7)] !== true
          : false
        usedMonths[dateString.slice(0, 7)] = true // set first day of month for next iteration
        return {
          dateString: dateString,
          isMonthStart: isMonthStart,
          isMonthEnd: isMonthEnd,
          isBeforeSchoolYear: dateString <= firstDateOfSchoolYear,
          isAfterSchoolYear: dateString >= lastDateOfSchoolYear,
          isOutsideSchoolYear:
            dateString > lastDateOfSchoolYear || dateString < firstDateOfSchoolYear,
          semesterId: rotationDate ? rotationDate.attributes.semesterId : null,
          rotationId: rotationDate ? rotationDate.attributes.rotationId : null,
        }
      })
      .value()
    // console.timeEnd('dates')
    // console.log('min', minDate, 'max', maxDate, dateRange)
    // return _.map(get(this, 'rotationCalendar.attributes.dates'), date => {
    //   return {dateString: date.dateString}
    // })
    // return _.chain(get(this, 'planbookCalendarDates')).values().sortBy('dateString').value()
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments)
    this.$(".js-timeline-wrapper").off("scroll")
  }

  @action
  highlightDates(range) {
    // let dateMap = _.reduce(dates, (acc, date) => _.set(acc, date, true), {})
    // set(this, 'highlightedDates', dates)
    if (range === false) {
      set(this, "highlightedDateRange", false)
    } else {
      set(this, "highlightedDateRange", range)
    }

    // _.each(get(this, 'dates'), date => {
    //   if(date.isHighlighted !== _.get(dateMap, date.dateString)){
    //     set(date, "isHighlighted", _.get(dateMap, date.dateString))
    //   }
    // })
  }

  @action
  hideCourseTitleBanner(val) {
    set(this, "courseTitleBannerIsHidden", val)
  }
}
